import { Outlet, useLocation } from 'react-router'
import DesktopEnvironment from '@/components/system/DesktopEnvironment'

export function MainLayout() {
  const location = useLocation()
  const isLoginRoute = location.pathname === '/'
  const isDesktopRoute = location.pathname === '/desktop'

  return (
    <div className="h-screen overflow-hidden bg-background">
      <DesktopEnvironment>
        <main className={
          isLoginRoute
            ? 'h-full overflow-hidden'
            : isDesktopRoute
              ? 'h-full overflow-hidden'
              : 'container mx-auto px-4 sm:px-6 lg:px-8 py-8'
        }>
          <Outlet />
        </main>
      </DesktopEnvironment>
    </div>
  )
}
